import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionTokenService } from '../services/session-token.service';

export const http401Interceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(SessionTokenService);
  const publicEndpoints = ['/api/import'];

  return next(req).pipe(
    catchError((error) => {
      if (
        error.status === 401 &&
        error.statusText === 'Unauthorized' &&
        !publicEndpoints.some((e) => req.url.includes(e))
      ) {
        authService.clear();
        router.navigate(['/']);
      }
      return throwError(() => error);
    })
  );
};
